import type { ButtonHTMLAttributes } from 'react';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
}

export function Button({ variant = 'primary', className = '', ...rest }: Props) {
  const base = variant === 'primary' ? 'btn-primary' : 'btn-secondary';
  return <button {...rest} className={`${base} ${className}`} />;
}
